export default "__VITE_ASSET__DlE_ZyMT__"